import { notification } from 'antd'
import {
  listAllAbstractUrl,
  deleteAbstractUrl,
  addAbstractUrl,
  updateAbstractUrl,
  sendAbstractEmailUrl,
  addAbstractNoteUrl,
  listAbstractNotesUrl,
  listAbstractActivityUrl,
  selectAbstractEmailUrl,
  lastAbstractNoUrl,
  createAbstractUrl,
  getSingleOnlineAbstractUrl,
  proceedAbstractSubmissionUrl,
  listAbstractsUrl,getSingleAbstractUrl,
  updateApprovedAbstractUrl,
  addAbstractViewNoteUrl,
  generateGraphicalAbstractUrl
} from '../apis'
import { getToken, customAxios as axios } from '../../../request'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'

/**
 * LIST ABSTRACTS
 */
export const listAllAbstract = async (filters) => {
  let config = {
    params: { ...filters },
    ...getToken()
  }

  let { data } = await axios.get(listAllAbstractUrl(), config)

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }

  return data
}

/**
 * ADD ABSTRACT
 */
export const addAbstractFxn = async (valData) => {
  let config = {
    ...getToken()
  }

  let { data } = await axios.post(addAbstractUrl(), valData, config)

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }

  return data
}
export const createAbstractFxn =(valData)=> async (dispatch) => {
  dispatch(showPageLoad());
  let config = {
    ...getToken()
  }

  let { data } = await axios.post(createAbstractUrl(), valData, config)
  dispatch(hidePageLoad());
  if (data.error) {
    dispatch(hidePageLoad());
    notification.error({
      message: data.message || 'Error'
    })
  }

  return data
}
export const deleteAbstractFxn = async (id) => {
  let config = {
    ...getToken()
  }

  let { data } = await axios.post(deleteAbstractUrl(), { abstractId: id }, config)

  if (data.error) {
    notification.error({
      message: data.message || 'Error deleting abstract'
    })
  }

  return data
}
// export const updateAbstractFxn = (valData) => async (dispatch) => {
//   dispatch(showPageLoad());
//   let config = {
//     ...getToken()
//   }
//   let { data } = await axios.post(updateAbstractUrl(), valData, config)
//
//   return data
// }
export const updateAbstractFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad());

  let config = {
    ...getToken()
  }

  try {
    let { data } = await axios.post(updateAbstractUrl(), valData, config);
    dispatch(hidePageLoad());

    if (data.success) {
      notification.success({
        message: 'Updated successfully'
      });
    } else {
      notification.error({
        message: data.message || 'Update failed'
      });
    }

    return data;

  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: 'Server error during update'
    });
    return { success: false, error: true };
  }
}
export const SendAbstractEmailAction = (payload) => async (dispatch) => {
  dispatch(showPageLoad());

  let config = {
    ...getToken()
  };

  try {
    let { data } = await axios.post(sendAbstractEmailUrl(), payload, config);


    dispatch(hidePageLoad());
    if (data.error || data.success === false) {
      notification.error({
        message: data.message || 'Error processing email request'
      });
    }

    return data;

  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: 'Server error while sending email'
    });
    return { success: false, error: true };
  }
};
/**
 * ADD NOTE TO ABSTRACT
 */
export const addAbstractNoteFxn = async (valData) => {
  let config = {
    ...getToken()
  };

  try {
    let { data } = await axios.post(addAbstractNoteUrl(), valData, config);

    if (data.error) {
      notification.error({
        message: data.message || 'Error adding note'
      });
    }

    return data;
  } catch (error) {
    notification.error({
      message: 'Server error while adding note'
    });
    return { success: false, error: true };
  }
};
/**
 * LIST NOTES FOR ABSTRACT
 */
export const listAbstractNotesFxn = async (query) => {
  let config = {
    params: { ...query },
    ...getToken()
  };

  try {
    let { data } = await axios.get(listAbstractNotesUrl(), config);
    return data;
  } catch (error) {
    console.error("Error fetching notes:", error);
    return [];
  }
};
export const FetchAbstractEmailDataAction = (id) => async (dispatch) => {
  let config = {
    ...getToken()
  };
  let { data } = await axios.get(selectAbstractEmailUrl(id), config);

  if (data.error) {
    notification.error({
      message: data.message || 'Error fetching email data'
    });
  }

  return data;
};
export const listAbstractActivityFxn = (query) => async (dispatch) => {
  let config = {
    params: { ...query },
    ...getToken()
  };

  try {
    let { data } = await axios.get(listAbstractActivityUrl(), config);

    if (data.error) {
      notification.error({
        message: data.message || 'Error fetching history'
      });
    }

    return data;
  } catch (error) {
    console.error("Error fetching abstract history:", error);
    notification.error({
      message: 'Server error while fetching history'
    });
    return { success: false, data: [] };
  }
};
export const lastAbstractNo = (obj) => {
  return async (dispatch) => {
    try {
      let config = { ...getToken() };
      let { data } = await axios.post(lastAbstractNoUrl(), obj, config);
      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  };
};
// software
export const FetchSingleOnlineAbstractAction = (id) => async (dispatch) => {
  let config = {
    ...getToken()
  };

  try {
    let { data } = await axios.get(getSingleOnlineAbstractUrl(id), config);

    if (data.error || data.success === false) {
      notification.error({
        message: data.message || 'Error fetching abstract information'
      });
    }

    return data;

  } catch (error) {
    console.error("Axios Error in FetchSingleOnlineAbstractAction:", error);
    notification.error({
      message: 'Server connectivity issue while loading abstract'
    });
    return { success: false, error: true };
  }
};
export const proceedAbstractSubmissionFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad());

  let config = {
    ...getToken()
  }

  try {
    let { data } = await axios.post(proceedAbstractSubmissionUrl(), valData, config);
    dispatch(hidePageLoad());

    if (data.success) {
      notification.success({
        message: 'Abstract processed successfully'
      });
    } else {
      notification.error({
        message: data.message || 'Processing failed'
      });
    }

    return data;

  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: 'Server error during submission conversion'
    });
    return { success: false, error: true };
  }
};
export const fetchAbstractsAction = (filters) => async (dispatch) => {
  dispatch(showPageLoad());

  let config = {
    params: { ...filters },
    ...getToken()
  };

  try {
    let { data } = await axios.get(listAbstractsUrl(), config);
    dispatch(hidePageLoad());

    if (data.error || data.success === false) {
      notification.error({
        message: data.message || 'Failed to fetch production abstract records'
      });
    }

    return data;

  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: 'Server connection dropout while downloading abstract lists'
    });
    return { success: false, data: [], total: 0 };
  }
};
export const FetchSingleApprovedAbstractAction = (id) => async (dispatch) => {
  let config = {
    ...getToken()
  };

  try {
    let { data } = await axios.get(getSingleAbstractUrl(id), config);

    if (data.error || data.success === false) {
      notification.error({
        message: data.message || 'Error loading production abstract details'
      });
    }

    return data;

  } catch (error) {
    console.error("Axios Error in FetchSingleApprovedAbstractAction:", error);
    notification.error({
      message: 'Connectivity issue occurred while fetching the production record'
    });
    return { success: false, error: true };
  }
};
export const updateApprovedAbstractFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad());

  let config = {
    ...getToken()
  }

  try {
    let { data } = await axios.post(updateApprovedAbstractUrl(), valData, config);
    dispatch(hidePageLoad());

    if (data.success) {
      notification.success({
        message: 'Production Abstract Updated Successfully'
      });
    } else {
      notification.error({
        message: data.message || 'Update request failed'
      });
    }

    return data;

  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: 'Server error encountered during file upload compilation'
    });
    return { success: false, error: true };
  }
}

export const generateGraphicalAbstractFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())

  let config = {
    ...getToken()
  }

  try {
    let { data } = await axios.post(generateGraphicalAbstractUrl(), valData, config)
    dispatch(hidePageLoad())

    if (data.success) {
      notification.success({
        message: 'AI Generation Successful',
        description: 'The graphical abstract has been successfully generated using AI.'
      });
    } else {
      notification.error({
        message: data.message || 'Generation request failed'
      });
    }

    return data;

  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: (error.response && error.response.data && error.response.data.message) || 'Failed to generate graphical abstract with AI.'
    });
    return { success: false, error: true };
  }
}
